import { gql } from '@apollo/client/core';

export const PAYMENT_DETAILS_FIELDS = gql`
  fragment PaymentDetailsFields on PaymentDetails {
    id
    amount
    confirmed_amount
    refundable_amount
    provider
    mode
    location_id
    location_title
    timezone
    created_at
    captured_at
    actor_title
    source_summary {
      customer_name
      description
    }
    status
    application_status
    order_id
    fiscal_operation_id
    transfer_details {
      payment_order_number
      received_on
      invoice_number
    }
    block_scope
    attention_reasons
    available_actions
    money_parts {
      id
      method
      planned_amount
      confirmed_amount
    }
    attempts {
      id
      status
      created_at
    }
    links {
      id
      status
      amount
      inv_id
      expires_at
      url
    }
    refunds {
      id
      amount
      status
      reason
      provider_request_id
      created_at
      actor_title
      transfer_reference
      transferred_on
      parts {
        method
        amount
      }
    }
    receipts {
      id
      issuer
      operation
      settlement_method
      status
      fn_number
      fd_number
      fiscal_sign
      fiscal_at
    }
    events {
      id
      type
      created_at
      from_status
      to_status
      reason_code
      message
      reason
      amount
    }
  }
`;

export const GET_PAYMENT_JOURNAL = gql`
  query GetPaymentJournal($filter: PaymentJournalFilter, $first: Int!, $after: String) {
    paymentJournal(filter: $filter, first: $first, after: $after) {
      edges {
        cursor
        node {
          key
          id
          payment_id
          kind
          amount
          provider
          methods
          transfer_details {
            payment_order_number
            received_on
            invoice_number
          }
          receipt_operation
          receipt_settlement_method
          receipt_fd_number
          receipt_issuer
          receipts_count
          location_id
          location_title
          timezone
          created_at
          actor_title
          reason
          payment_captured_at
          failure_kind
          failure_message
          failure_reason_code
          source_summary {
            customer_name
            description
          }
          money_status
          receipt_status
          attention_reasons
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;
export const GET_PAYMENT = gql`
  ${PAYMENT_DETAILS_FIELDS}
  query GetPayment($id: ID!) {
    payment(id: $id) {
      ...PaymentDetailsFields
    }
  }
`;
/** `GetLocationAttention` — число «Нужно решить» на плашке локации. */
export const paymentQueryNames = ['GetPaymentJournal', 'GetPayment', 'GetLocationAttention'] as const;
